import OperationNonRecurringTimeDependent from "./operation/OperationNonRecurringTimeDependent";
import OperationPerPartTimeDependent from "./operation/OperationPerPartTimeDependent";
import MaterialPurchasedComponent from "./operation/MaterialPurchasedComponent";
import MaterialRectangularBar from "./operation/MaterialRectangularBar";
import MaterialRoundBar from "./operation/MaterialRoundBar";
import MaterialPlateSheet from "./operation/MaterialPlateSheet";
import ExpenseNonRecurring from "./operation/ExpenseNonRecurring";
import MaterialRectangularTube from "./operation/MaterialRectangularTube";
import CuttingOperations from "./operation/CuttingOperations";
import FinishingOperationAreaDependent from "./operation/FinishingOperationAreaDependent";
import { OperationType } from "./lib/types";
import PurchasedComponent from "./operation/PurchasedComponent";
import MaterialCustomerProvided from "./operation/MaterialCustomerProvided";
import LaserCutting from "./operation/LaserCutting";
import WaterjetCutting from "./operation/WaterjetCutting";
import MaterialPlate from "./operation/MaterialPlate";
import MaterialSheet from "./operation/MaterialSheet";

export default function SwitchOperation({ type }: { type: OperationType }) {
  switch (type) {
    case "MaterialPurchasedComponent":
      return <MaterialPurchasedComponent />;
    case "OperationNonRecurringTimeDependent":
      return <OperationNonRecurringTimeDependent />;
    case "OperationPerPartTimeDependent":
      return <OperationPerPartTimeDependent />;
    case "MaterialRectangularBar":
      return <MaterialRectangularBar />;
    case "MaterialRoundBar":
      return <MaterialRoundBar />;
    case "MaterialPlateSheet":
      return <MaterialPlateSheet />;
    case "MaterialPlate":
      return <MaterialPlate />;
    case "MaterialSheet":
      return <MaterialSheet />;
    case "ExpenseNonRecurring":
      return <ExpenseNonRecurring />;
    case "MaterialRectangularTube":
      return <MaterialRectangularTube />;
    case "CuttingOperations":
      return <CuttingOperations />;
    case "LaserCutting":
      return <LaserCutting />;
    case "WaterjetCutting":
      return <WaterjetCutting />;
    case "FinishingOperationAreaDependent":
      return <FinishingOperationAreaDependent />;
    case "PurchasedComponent":
      return <PurchasedComponent />;
    case "MaterialCustomerProvided":
      return <MaterialCustomerProvided />;
    default:
      console.error("Unknown operation type:", type);
      return null;
  }
}
